import { render, staticRenderFns } from "./ManagementGiftForm.vue?vue&type=template&id=4ca0ff50"
import script from "./ManagementGiftForm.vue?vue&type=script&lang=js"
export * from "./ManagementGiftForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports